/* Velmora – video slider.
   - Endless slider: the cards move slowly and evenly to the RIGHT. The set of cards is repeated and the
     track loops by exactly whole set widths, so there is never a stop, jump or empty gap.
     Engine: Web Animations API on transform (runs on the compositor → smooth).
   - Click-to-play: nothing loads or plays until play is clicked; then it plays inline with sound.
     Starting one video pauses the others.
   - The slider pauses while a video is ACTUALLY playing (video 'play'/'playing' events) and continues
     when no video is playing any more ('pause'/'ended').
   - Drag with the mouse / swipe on mobile moves the slider; the arrows nudge it. */
(function () {
  if (window.__vmVids3) return; window.__vmVids3 = true;
  var SPEED = 28;                                   /* px per second */
  var videos = [];

  function anyPlaying() { for (var i = 0; i < videos.length; i++) { var v = videos[i]; if (!v.paused && !v.ended) return true; } return false; }

  /* ---------- playback ---------- */
  function pauseOthers(me) { videos.forEach(function (v) { if (v !== me && !v.paused) v.pause(); }); }
  function build(frame) {
    var card = frame.closest('[data-vm-card]');
    var video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    video.poster = frame.dataset.poster ? frame.dataset.poster + '?width=720' : '';
    video.muted = false;
    var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    video.src = narrow && frame.dataset.srcSd ? frame.dataset.srcSd : frame.dataset.src;
    function sync() { card.classList.toggle('is-playing', !video.paused && !video.ended); document.dispatchEvent(new CustomEvent('vm:playstate')); }
    video.addEventListener('play', function () { pauseOthers(video); sync(); });
    video.addEventListener('playing', function () { frame.classList.remove('is-loading'); frame.classList.add('is-started'); sync(); });
    video.addEventListener('pause', sync);
    video.addEventListener('ended', function () {
      frame.classList.remove('is-started');          /* back to preview image + play button */
      try { video.currentTime = 0; } catch (e) {}
      sync();
    });
    video.addEventListener('error', function () {
      if (frame.dataset.srcSd && video.src.indexOf('SD-480p') === -1) { video.src = frame.dataset.srcSd; video.play().catch(function () {}); }
      else { frame.classList.remove('is-loading'); }
    });
    frame.insertBefore(video, frame.firstChild);
    videos.push(video);
    return video;
  }
  function play(frame) {
    var video = frame.querySelector('video') || build(frame);
    frame.classList.add('is-loading', 'is-started');
    video.muted = false;
    video.volume = 1;
    var p = video.play();
    if (p && p.catch) p.catch(function () { frame.classList.remove('is-loading'); });
  }

  /* ---------- endless slider ---------- */
  function Slider(sec) {
    var view = sec.querySelector('[data-vm-viewport]');
    var track = sec.querySelector('[data-vm-row]');
    if (!view || !track || track.__vm) return; track.__vm = true;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;
    var setW = 0, L = 0, dur = 0, anim = null, lastW = 0, dragging = false, playing = false, nudging = 0;

    function addSet() {
      originals.forEach(function (n) {
        var x = n.cloneNode(true); x.classList.add('is-clone'); x.setAttribute('aria-hidden', 'true');
        x.querySelectorAll('button').forEach(function (b) { b.tabIndex = -1; });
        x.querySelectorAll('video').forEach(function (v) { v.remove(); });          /* clones start as fresh previews */
        x.classList.remove('is-playing');
        x.querySelectorAll('[data-vm-vid]').forEach(function (f) { f.classList.remove('is-started', 'is-loading'); });
        track.appendChild(x);
      });
    }
    /* position = how far the track has moved to the right inside one loop (0..L) */
    function getPos() { if (!anim || !dur) return 0; var t = anim.currentTime || 0; return ((t % dur) + dur) % dur / dur * L; }
    function setPos(p) { if (!anim || !L) return; p = ((p % L) + L) % L; anim.currentTime = p / L * dur; }
    function apply() {
      if (!anim) return;
      if (dragging || playing || nudging) anim.pause(); else anim.play();
    }
    function layout() {
      if (playing) return;                             /* never rebuild while a video is playing */
      Array.prototype.slice.call(track.querySelectorAll('.is-clone video')).forEach(function (v) {
        var i = videos.indexOf(v); if (i > -1) videos.splice(i, 1);
      });
      var frac = L ? getPos() / L : 0;
      if (anim) { anim.cancel(); anim = null; }
      Array.prototype.slice.call(track.querySelectorAll('.is-clone')).forEach(function (n) { n.remove(); });
      addSet();
      setW = track.querySelector('.is-clone').offsetLeft - originals[0].offsetLeft;   /* one set incl. spacing */
      if (setW <= 0) return;
      var k = Math.max(1, Math.ceil((view.clientWidth + 2) / setW));
      for (var i = 1; i < 2 * k - 1; i++) addSet();                                 /* 2k sets in total */
      L = k * setW; dur = L / SPEED * 1000;
      /* moving RIGHT: start shifted left by one loop and travel to 0, then repeat seamlessly */
      anim = track.animate([{ transform: 'translate3d(' + (-L) + 'px,0,0)' }, { transform: 'translate3d(0px,0,0)' }],
                           { duration: dur, iterations: Infinity, easing: 'linear' });
      anim.currentTime = frac * dur;
      lastW = view.clientWidth;
      apply();
    }

    /* pause while any video in this slider is really playing */
    document.addEventListener('vm:playstate', function () {
      var p = false;
      track.querySelectorAll('video').forEach(function (v) { if (!v.paused && !v.ended) p = true; });
      playing = p; apply();
    });

    /* arrows: smooth nudge by ~2 cards */
    function nudge(dir) {
      if (!anim) return;
      var card = originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(originals[0]).marginRight || 0);
      var from = getPos(), to = from + dir * card * 2, t0 = performance.now(), D = 600;
      nudging++; apply();
      (function step(t) {
        var k = Math.min(1, Math.max(0, (t - t0) / D)), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        setPos(from + (to - from) * e);
        if (k < 1) requestAnimationFrame(step); else { nudging--; apply(); }
      })(t0);
    }
    var prev = sec.querySelector('[data-vm-prev]'), next = sec.querySelector('[data-vm-next]');
    if (prev) { prev.disabled = false; prev.addEventListener('click', function () { nudge(-1); }); }
    if (next) { next.disabled = false; next.addEventListener('click', function () { nudge(1); }); }

    /* drag (mouse) / swipe (touch) – a real drag never triggers a play click */
    var down = false, axis = '', pid = null, sx = 0, sy = 0, start = 0, moved = false;
    view.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('video')) return;          /* keep native video controls usable */
      down = true; pid = e.pointerId; sx = e.clientX; sy = e.clientY; moved = false; axis = '';
    });
    view.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      if (!axis) {
        var ax = Math.abs(e.clientX - sx), ay = Math.abs(e.clientY - sy);
        if (ax < 6 && ay < 6) return;
        axis = ax > ay ? 'x' : 'y';
        if (axis === 'x') {
          try { view.setPointerCapture(pid); } catch (x) {}
          dragging = true; apply(); start = getPos(); sx = e.clientX; view.classList.add('is-dragging');
        }
      }
      if (axis !== 'x') return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 3) moved = true;
      setPos(start + dx);                              /* follow the pointer 1:1 */
    });
    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      var was = axis === 'x'; down = false; axis = '';
      if (!was) return;
      view.classList.remove('is-dragging');
      dragging = false; apply();
    }
    view.addEventListener('pointerup', end);
    view.addEventListener('pointercancel', end);
    view.addEventListener('lostpointercapture', function (e) { if (e.target === view) end(e); });
    view.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    view.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (!dragging && view.clientWidth !== lastW) layout(); }, 200);
    });
    window.addEventListener('load', function () { if (!dragging) layout(); });
    layout();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vm-vid__play');
    if (!btn) return;
    var frame = btn.closest('[data-vm-vid]');
    if (frame) { e.preventDefault(); play(frame); }
  });
  function boot() { document.querySelectorAll('[data-vm-section]').forEach(Slider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
